import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import type { SubscriberPage, SubscriberSortBy } from '../models/subscriber'
import { GetSubscribersQuery } from '../../data/queries/get-subscribers.query'
import type { SubscriberPageEntity } from '../../data/entities/subscriber.entity'

export interface GetSubscribersParams {
  search?: string | null
  fuzzy?: boolean
  region?: string[] | null
  country?: string[] | null
  subscriptionSource?: string[] | null
  subscriptionPlan?: string[] | null
  subscriptionLevel?: string[] | null
  previousSubscriptionLevel?: string[] | null
  subscriptionStatuses?: string[] | null
  sortBy: SubscriberSortBy
  sortOrder: 'asc' | 'desc'
  offset: number
  limit: number
  organization: string
}

export class GetSubscribersInteractor {
  constructor(private readonly repository: GetInteractor<SubscriberPageEntity>) {}

  public async execute(params: GetSubscribersParams): Promise<SubscriberPage> {
    return await this.repository.execute(
      new GetSubscribersQuery(
        params.search ?? null,
        params.region ?? null,
        params.country ?? null,
        params.subscriptionSource ?? null,
        params.subscriptionPlan ?? null,
        params.subscriptionLevel ?? null,
        params.previousSubscriptionLevel ?? null,
        params.subscriptionStatuses ?? null,
        params.sortBy,
        params.sortOrder,
        params.offset,
        params.limit,
        params.organization,
        params.fuzzy ?? false
      )
    )
  }
}
